import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {OrdersService} from "./orders.service";
import {
    CardDataOptions,
    ElementOptions,
    ElementsOptions,
    StripeCardComponent,
    StripeService
} from '@nomadreservations/ngx-stripe';
import {PaymentIntentService} from "./paymentIntent.service";
import {DefaultComponent} from "../../shared/components/default.component";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {environment} from "../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";
import {IonModal, LoadingController, ToastController} from "@ionic/angular";
import {TokenStorage} from "../../shared/_services/token-storage.service";
import {SharedUserService} from "../../shared/_services/shareduser.service";

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
})
export class OrderComponent extends DefaultComponent implements OnInit, AfterViewInit, OnDestroy {
    private key: any;
    @ViewChild(IonModal) modal: IonModal;
    orderForm!: UntypedFormGroup;
    submitted = false;
    error: any = {};
    showErrors = false;
    hide = true;

    isKey: boolean = false;

    stripeKey: string = 'pk_test_51MU2EMCcuF6nhyS83kfz69UVB0kuvvcRe6Ww9PamFuNxKcg7rUGurxlgpewNLXRfjwssbRnp3wBxXbMWLhnTnGQv008RVSiIxF';
    @ViewChild(StripeCardComponent) card: StripeCardComponent;

    cardOptions: ElementOptions = {
        hidePostalCode: true,
        style: {
            base: {
                iconColor: '#666EE8',
                color: '#fff',
                lineHeight: '70px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                    color: '#ffffff'
                },

            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        },
    };

    elementsOptions: ElementsOptions = {
    locale: 'en',

    };
    order: any = {};
    private iserror: boolean;
    private activ: boolean;
    payment: any;
    public paymentResult: string;
    paymentStatus: boolean = false;
    price: any;
    energy_rate: any;
    errorMessage: any;
    intentStatus: boolean = false;
    isLoading = false;


    constructor(
        private formBuilder: UntypedFormBuilder,
        router: Router,
        activatedRoute: ActivatedRoute,
        sharedRoutesService: SharedRoutesService,
        private ordersService: OrdersService,
        private paymentIntentService: PaymentIntentService,
        private stripeService: StripeService,
        private loadingCtrl: LoadingController,
        private tokenStorage: TokenStorage,
        private sharedUserService: SharedUserService,
        toastController: ToastController
    ) {
        super(router, activatedRoute, sharedRoutesService,toastController);
    }

    ngOnInit() {


    }

    ngAfterViewInit() {
        this.key = this.activatedRoute.snapshot.paramMap.get('key');
        //console.log('key', this.key);
        this.orderForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            amount: ['', Validators.required],
            name: ['', Validators.required],
            // address: ['', Validators.required],
        });

        this.intentStatus = true;
        //@todo get this from environment
        this.stripeService.changeKey("pk_test_51MU2EMCcuF6nhyS83kfz69UVB0kuvvcRe6Ww9PamFuNxKcg7rUGurxlgpewNLXRfjwssbRnp3wBxXbMWLhnTnGQv008RVSiIxF");
        if(this.key == null || this.key == undefined || this.key == '') {
        console.log('noKey');
        } else {
            this.onStart();
        }
//http://localhost:4200/public/main/order/Z7e24z6Aqnpa3btR4R186usDjrlluPmd

    }

    override ngOnDestroy() {
    }


    onStart() {
        const queryParams: any = {
            key: this.key
        }
        this.ordersService
            .getOrderInfo(queryParams)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
// @ts-ignore
                data => {
                    if (data) {
                        this.energy_rate = data.energy_rate;
                    }
                    // console.log("login success");
                    this.intentStatus = true;
                    //main route after login
                    // this.router.navigate(['/private/dashboard']);
                }
            );


    }

    public setChargerKey() {
        localStorage.setItem('charger-token', this.key);
        //console.log('set', this.key);
        // localStorage.removeItem('charger-token');
    }
    public setUserKey(data: any) {
        localStorage.setItem('authentication-token', data.session.token);
        localStorage.setItem('user', JSON.stringify(data.user));
       // console.log('set', data);
        this.setChargerKey();
        setTimeout(function(){
            window.location.reload();
        }, 3000);

        // localStorage.removeItem('charger-token');
    }


    createPayment() {
        this.isLoading = true;
        this.loadingCtrl.create({keyboardClose: true, message: 'Processing payment..'}).then(loadingEl => {
            loadingEl.present();
            const queryParams = {

                data: this.orderForm.value,
                calculated_price: this.price,
                key: this.key,
                cart_id: 1
            };

            //console.log('card', this.card);
            return this.paymentIntentService.create(queryParams)
                .subscribe(result => {
                    // console.log('ajung', result);
                    if ((result as any).client_secret != null && (result as any).client_secret != undefined && (result as any).client_secret != '') {
                        this.stripeService
                            // @ts-ignore
                            .handleCardPayment((result as any).client_secret, this.card.getCard())
                            .subscribe(data => {
                                if (data.paymentIntent.id) {
                                    const paymentParams = {
                                        id: data.paymentIntent.id,
                                        key: this.key,
                                    }
                                    this.paymentIntentService.validatePayment(paymentParams).subscribe(result => {
                                        if(result.status=="success") {


                                          // this might be a security issue - have to check
                                            if(this.key != null || this.key != undefined || this.key != '') {
                                                this.setChargerKey();
                                                this.setUserKey(result);
                                            }
                                            //end
                                            this.paymentResult = 'Success';
                                            this.paymentStatus = true;
                                            this.intentStatus = true;
                                            console.log('success', result);
                                            loadingEl.dismiss();
                                            }
                                        else {
                                            this.paymentResult = 'Error';
                                            this.paymentStatus = false;
                                            this.intentStatus = false;
                                            loadingEl.dismiss();
                                            console.log('error', result);
                                        }
                                    })
                                } else {
                                    this.paymentResult = data.error.code;
                                    this.paymentStatus = false;
                                    this.intentStatus = false;
                                    loadingEl.dismiss();
                                    console.log('error', data);
                                }
                            });

                    } else {
                        loadingEl.dismiss();
                        this.paymentResult = 'Error';
                        this.intentStatus = false;
                        this.energy_rate = null;
                        console.log('error', result);
                        console.log('sta', this.intentStatus);
                    }
                });
        });
    }

    change(event) {
        if (event.complete == true) {
            this.iserror = false;
            this.showErrors = false;
            this.activ = true;
        } else {
            console.log('err', event);
            this.error = event.card.error;
            this.errorMessage = this.error.message;
            console.log('error', this.error)
            this.iserror = true;
            this.showErrors = true;
        }
    }

    round(number, precision) {
        var factor = Math.pow(10, precision);
        var tempNumber = number * factor;
        var roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    };


    updatePrice($event: Event) {
        this.price = this.orderForm.value.amount * this.energy_rate;

    }


}

//
